import React from 'react';

const ShopsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="33"
    height="31"
    viewBox="0 0 33 31"
  >
    <g fill="none">
      <path d="M0.3 6.6L2.2 11.5 6.9 11.5 6.9 6.7 0.3 6.6ZM2.4 27.6C2.4 28.5 2.8 29.3 3.4 30 4.1 30.7 5 31 5.9 31 6.9 31 7.7 30.7 8.4 30 9.1 29.3 9.4 28.5 9.4 27.6 9.4 26.6 9.1 25.8 8.4 25.1 7.7 24.5 6.9 24.1 5.9 24.1 5 24.1 4.1 24.5 3.4 25.1 2.8 25.8 2.4 26.6 2.4 27.6L2.4 27.6ZM2.6 12.8L4.4 17.6 6.9 17.6 6.9 12.8 2.6 12.8ZM4.9 18.8L6.6 23.1 6.9 23.1 6.9 18.8 4.9 18.8ZM8.2 11.5L13.6 11.5 13.7 6.8 8.1 6.7 8.2 11.5ZM8.2 23.1L13.7 22.9 13.6 18.8 8.3 18.8 8.2 23.1ZM8.3 17.6L13.6 17.6 13.7 12.8 8.2 12.8 8.3 17.6ZM14.8 11.5L20.3 11.5 20.3 6.9 14.9 6.8 14.8 11.5ZM14.9 22.9L20.3 22.8 20.4 18.8 14.9 18.8 14.9 22.9ZM14.9 17.6L20.4 17.6 20.3 12.8 14.9 12.8 14.9 17.6ZM20.5 27.6C20.5 28.5 20.8 29.3 21.5 30 22.2 30.7 23 31 24 31 24.9 31 25.7 30.7 26.5 30 27.1 29.3 27.5 28.5 27.5 27.6 27.5 26.6 27.1 25.8 26.5 25.1 25.7 24.5 24.9 24.1 24 24.1 23 24.1 22.2 24.5 21.5 25.1 20.8 25.8 20.5 26.6 20.5 27.6ZM21.7 11.5L26.9 11.5 27.9 6.9 21.8 6.9 21.7 11.5ZM21.8 22.8L24.5 22.8 25.4 18.8 21.8 18.8 21.8 22.8ZM21.8 17.6L25.7 17.6 26.8 12.8 21.8 12.8 21.8 17.6ZM24.5 5.8L28.3 5.8 32.8 2.9 31.1 0.6 24.5 5.8Z" />
    </g>
  </svg>
);

export default ShopsIcon;
